import { Alert, Col, Row, Space } from 'antd';
import { useEffect, useState } from 'react';

import { Button } from '../../../components/index';
import { CheckList } from '../../../components/common/CheckList';
import { Document } from '../../../types';
import { BaseActionModalProps } from './staymentActions';

type ReleaseUndockingModalProps = BaseActionModalProps & {
  onRelease: () => void;
};

const releaseUndockingConsents = [
  {
    checked: true,
    title: 'Autoridade Marítima - desatracação',
    name: 'maritime_authority',
  },
  {
    checked: true,
    title: 'Autoridade de polícia marítima - desatracação',
    name: 'port_admin_maritime_police',
  },
];

export function ReleaseUndockingModal(props: ReleaseUndockingModalProps) {
  const {
    setIsVisible,
    onRelease,
    currentDocking,
    stopover,
    updateDocking,
    isLoadingUpdateDocking,
  } = props;
  const [consents, setConsents] = useState<Document[]>([]);
  const [data, setData] = useState([
    {
      checked: currentDocking?.input_draught !== null,
      title: 'Calado de entrada',
    },
    { checked: currentDocking?.input_dwt !== null, title: 'DWT de entrada' },
    {
      checked: currentDocking?.entrance_displacement !== null,
      title: 'Deslocamento para entrada',
    },
  ]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  useEffect(() => {
    const stopoverDocumentsConsents: Document[] = [];
    releaseUndockingConsents.forEach((documentConsent) => {
      const stopoverDocument = stopover?.documents?.find(
        (stopoverDocument) => stopoverDocument.name === documentConsent.name
      );
      if (stopoverDocument) {
        stopoverDocumentsConsents.push(stopoverDocument);
      }
    });
    setConsents(stopoverDocumentsConsents);
  }, [stopover]);

  useEffect(() => {
    if (
      !consents.find((consent) => !consent.checked) &&
      !data.find((dataItem) => !dataItem.checked)
    ) {
      setIsAllChecked(true);
    } else {
      setIsAllChecked(false);
    }
  });

  function releaseUndocking() {
    const release = isAllChecked ? 'RELEASED' : 'RELEASED_WITH_PENDING';
    if (updateDocking) {
      updateDocking(
        {
          undocking_release: release,
          id: currentDocking?.id,
        },
        onRelease
      );
    }
  }
  return (
    <>
      {isAllChecked && <b>Todos os requisitos foram preenchidos</b>}
      {!isAllChecked && (
        <b>Todos os requisitos abaixo devem estar preenchidos:</b>
      )}
      <Row style={{ marginTop: '10px' }}>
        <Col span={12}>
          <CheckList title="Dados:" items={data} />
        </Col>
        <Col span={12}>
          <CheckList title="Anuências:" items={consents} labelField="label" />
        </Col>
      </Row>
      <Alert
        message="Após liberar início de operação o status da embarcação será alterado para “Desatracação”."
        type="info"
      />
      <Space
        size={12}
        style={{
          justifyContent: 'flex-end',
          display: 'flex',
          marginTop: '20px',
        }}
      >
        <Button type="text" onClick={() => setIsVisible(false)}>
          Cancelar
        </Button>
        <Button
          type="primary"
          onClick={() => releaseUndocking()}
          loading={isLoadingUpdateDocking}
        >
          {isAllChecked && 'Liberar'}
          {!isAllChecked && 'Liberar mesmo assim'}
        </Button>
      </Space>
    </>
  );
}
